// @flow

import React, {Component} from 'react';
import ReactHighcharts from 'react-highcharts';
// Highcharts more
import HighchartsMore from 'highcharts-more';
HighchartsMore(ReactHighcharts.Highcharts);
// Highcharts exporting
import HighchartsExporting from 'highcharts-exporting';
HighchartsExporting(ReactHighcharts.Highcharts);
import Paper from 'material-ui/Paper';
import update from 'immutability-helper';
import {references} from '../constants';

const zoneColors = [
  '#006400',
  '#7F8400',
  '#FFA500',
  '#F96E00',
  '#EE0000'
];

const categ = ["n/y", "> 1 mm", "> 2 mm", "> 3 mm", "> 4 mm"];

const config = {
  credits: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  xAxis: {
    title: {
      text: 'ECE width'
    },
    categories: categ,
    tickmarkPlacement: "on",
    min: 0.5,
    max: categ.length-1.5,
    startOnTick: false,
    endOnTick: false,
    minPadding: 0,
    maxPadding: 0,
    align: "left"
  },
  yAxis: {
    title: {
      text: 'Probability',
    },
    gridLineWidth: 0
  },
  colors: zoneColors,
  chart: {
    height: 500,
    zoomType: 'xy',
    animation: true
  },
  series: [
    {
      name: 'L1',
      type: 'arearange',
      data: [[0,references[0][0]], [0,references[0][1]], [0,references[0][2]], [0,references[0][3]], [0,references[0][4]]],
      lineWidth: 0,
      fillOpacity: 0.3,
      states: {
        hover: {
          enabled: false
        }
      },
      animation: false
    },
    {
      name: 'L2',
      type: 'arearange',
      data: [[references[0][0], references[1][0]], [references[0][1], references[1][1]], [references[0][2], references[1][2]], [references[0][3], references[1][3]], [references[0][4], references[1][4]]],
      lineWidth: 0,
      fillOpacity: 0.3,
      states: {
        hover: {
          enabled: false
        }
      },
      animation: false
    },
    {
      name: 'R2',
      type: 'arearange',
      data: [[references[1][0], references[2][0]], [references[1][1], references[2][1]], [references[1][2], references[2][2]], [references[1][3], references[2][3]], [references[1][4], references[2][4]]],
      lineWidth: 0,
      fillOpacity: 0.3,
      states: {
        hover: {
          enabled: false
        }
      },
      animation: false
    },
    {
      name: 'R1',
      type: 'arearange',
      data: [[references[2][0], references[3][0]], [references[2][1], references[3][1]], [references[2][2], references[3][2]], [references[2][3], references[3][3]], [references[2][4], references[3][4]]],
      lineWidth: 0,
      fillOpacity: 0.3,
      states: {
        hover: {
          enabled: false
        }
      },
      animation: false
    },
    {
      name: '> R1',
      type: 'arearange',
      data: [[references[3][0], 1], [references[3][1], 1], [references[3][2], 1], [references[3][3], 1], [references[3][4], 1]],
      lineWidth: 0,
      fillOpacity: 0.3,
      states: {
        hover: {
          enabled: false
        }
      },
      animation: false,
      showInLegend: false,
      enableMouseTracking: false,
    },
  ],
  tooltip: {
    formatter: function() {
      let series = this.series.chart.series;
      let areaRanges = series.slice(0,-1);
      let line = series.slice(-1)[0];

      for (let areaRange of areaRanges) {
        let range = areaRange.processedYData[this.point.index];
        let value = line.processedYData[this.point.index];

        if (value < range[1]) {
          return  this.x + '<br/><span style="color: '+ this.point.color + '">▲</span><b>' + line.name + ': ' + (value*100).toFixed(1) + '%</b><br/><span style="color: '+ areaRange.color + '; opacity: 0.5">■</span><b>Range: ' + (range[0]*100).toFixed(1) + '% ~ ' + (range[1]*100).toFixed(1) + '%';
        }
      }
    }
  },
  spacing: [0, 0, 0, 0]
};

const output = {
  name: 'Probability',
  id: 'output',
  type: 'line',
  marker: {
    symbol: 'triangle',
    radius: 7,
    lineColor: '#000000'
  },
  states: {
    hover: {
      halo: {
        size: 13
      }
    }
  },
  // animation: false,
  zoneAxis: 'x',
  tooltip: {
    pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y:.4f}</b><br/>',
  }
};

type Props = {
  isPrinting: boolean;
  pr: {
    l: Array<number>,
    r: Array<number>
  };
  colors: {
    l: Array<string>,
    r: Array<string>
  }
};

class Charts extends Component {
  props: Props;
  configLeft: any;
  configRight: any;
  left: any;
  right: any;
  parentHeight: number;

  constructor(props: Props) {
    super(props);

    const outputLeft = update(output,
      {
        data: {
          $set: this.props.pr.l
        },
        zones: {
          $set: [
            {
              value: 1,
              color: this.props.colors.l[0]
            },
            {
              value: 2,
              color: this.props.colors.l[1]
            },
            {
              value: 3,
              color: this.props.colors.l[2]
            },
            {
              value: 4,
              color: this.props.colors.l[3]
            },
            {
              value: 5,
              color: this.props.colors.l[4]
            }
          ]
        }
      }
    );

    const outputRight = update(output,
      {
        data: {
          $set: this.props.pr.r
        },
        zones: {
          $set: [
            {
              value: 1,
              color: this.props.colors.r[0]
            },
            {
              value: 2,
              color: this.props.colors.r[1]
            },
            {
              value: 3,
              color: this.props.colors.r[2]
            },
            {
              value: 4,
              color: this.props.colors.r[3]
            },
            {
              value: 5,
              color: this.props.colors.r[4]
            }
          ]
        }
      }
    );

    this.configLeft = update(config,
      {
        title: {
          $set: {
            text: 'Left lobe'
          }
        },
        series: {
          $push: [ outputLeft ]
        },
        yAxis: {
          min: {
            $set: 0
          },
          max: {
            $set: Math.max(...this.props.pr.l)
          }
        }
      }
    );
    this.configRight = update(config,
      {
        title: {
          $set: {
            text: 'Right lobe'
          }
        },
        series: {
          $push: [ outputRight ]
        },
        yAxis: {
          min: {
            $set: 0
          },
          max: {
            $set: Math.max(...this.props.pr.r)
          }
        }
      }
    );
  }

  componentWillUpdate(nextProps: Props) {
    let left = this.left.getChart();
    let right = this.right.getChart();

    left.get('output').update({
      zones: [
        {
          value: 1,
          color: nextProps.colors.l[0]
        },
        {
          value: 2,
          color: nextProps.colors.l[1]
        },
        {
          value: 3,
          color: nextProps.colors.l[2]
        },
        {
          value: 4,
          color: nextProps.colors.l[3]
        },
        {
          value: 5,
          color: nextProps.colors.l[4]
        }
      ]
    });
    left.get('output').setData(nextProps.pr.l);
    left.yAxis[0].setExtremes(0, Math.max(...nextProps.pr.l));

    right.get('output').update({
      zones: [
        {
          value: 1,
          color: nextProps.colors.r[0]
        },
        {
          value: 2,
          color: nextProps.colors.r[1]
        },
        {
          value: 3,
          color: nextProps.colors.r[2]
        },
        {
          value: 4,
          color: nextProps.colors.r[3]
        },
        {
          value: 5,
          color: nextProps.colors.r[4]
        }
      ]
    });
    right.get('output').setData(nextProps.pr.r);
    right.yAxis[0].setExtremes(0, Math.max(...nextProps.pr.r));
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.isPrinting !== this.props.isPrinting) {

      let left = this.left.getChart(), right = this.right.getChart();

      let updatedConfig = {
        chart: {
          height: this.parentHeight,
          animation: !left.options.chart.animation
        }
      };
      left.update(updatedConfig);
      left.reflow();

      right.update(updatedConfig);
      right.reflow();
    }
  }

  render() {
    let style = {};
    if (this.props.isPrinting) {
      this.parentHeight = 800;
      style = { display: "block", width:"100%", height: this.parentHeight, pageBreakBefore: "always"
    };
    } else {
      this.parentHeight = 500;
      style = {float: "left", margin: "1%", width: "48%", height: this.parentHeight};
    }
    return (
      <div>
         <Paper style={
           style
          }
           zDepth={1}
           transitionEnabled={false}
           >
          <ReactHighcharts
            config={this.configLeft}
            ref={(left) => {this.left = left;}}
            isPureConfig
          />
         </Paper>
         <Paper style={
           style
         } zDepth={1}
         transitionEnabled={false}
         >
          <ReactHighcharts
            config={this.configRight}
            ref={(right) => {this.right = right;}}
            isPureConfig
          />
         </Paper>
      </div>
    );
  }
}

export default Charts;



/** WEBPACK FOOTER **
 ** ./src/Components/Charts.js
 **/